import produce from 'immer';
import initialSnapshot from '~/initialSnapshot';
import {designParamsPresent} from '~/utils/url';
import WelcomeTypes from '~/constants/types/WelcomeTypes';
import {WELCOME, WELCOME_BACK} from '~/constants/WelcomeConstants';

function getWelcomeState() {
  if (designParamsPresent() || initialSnapshot) {
    return WELCOME_BACK;
  } else {
    return WELCOME;
  }
}

export function initialState() {
  return {
    stage: getWelcomeState(),
    animateMenuEntry: false
  };
}

export default function welcome(state = initialState(), action) {
  switch (action.type) {
    case WelcomeTypes.SET_RESTING_STATE: {
      return produce(state, draft => {
        draft.stage =
          action.payload && action.payload.icons.length > 0
            ? WELCOME_BACK
            : WELCOME;
      });
    }
    default:
      return state;
  }
}
